import { Directive, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { DataBindingDirective, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { KendoGridService } from '../services/kendo-grid.service';
import { Subscription } from 'rxjs';
import { GridConfig } from '../models/grid/grid-config.model';
import { FieldDefinitionService } from '../services/field-definition.service';
import { IGetCellDisplayValue } from '../models/grid/grid-interfaces';
import { HttpClient } from '@angular/common/http';

@Directive({
    selector: '[kendoGridRemoteBinding]',
    exportAs: 'kendoGridRemoteBindingRef',
    standalone: false
})
export class KendoGridRemoteBindingDirective extends DataBindingDirective implements OnInit, OnDestroy {

    @Input() gridConfig: GridConfig;
    @Input() fieldDefinitionService: FieldDefinitionService;
    @Input() getCellDisplayValue: IGetCellDisplayValue;
    @Input() formInstanceElementId: number;
    @Input() kendoGridService: KendoGridService;

    @Output() notifyLoaded: EventEmitter<any> = new EventEmitter();

    private serviceSubscription: Subscription;

    constructor(private http: HttpClient, grid: GridComponent) {
        super(grid);
    }

    public ngOnInit(): void {
        this.serviceSubscription = this.kendoGridService.subscribe((result) => {
            this.grid.loading = false;
            this.grid.data = result;
            this.notifyDataChange();
            this.notifyLoaded.emit({ count: this.grid.data.data.length, gridData: result });
        });

        super.ngOnInit();
        this.rebind();
    }

    public ngOnDestroy(): void {
        if (this.serviceSubscription) {
            this.serviceSubscription.unsubscribe();
        }

        super.ngOnDestroy();
    }

    public rebind(): void {
        if (this.formInstanceElementId > 0) {
            this.grid.loading = true;
            this.kendoGridService.read(this.gridConfig, this.fieldDefinitionService, this.getCellDisplayValue, this.formInstanceElementId, this.state);
        }
    }

    public get Data(): GridDataResult {
        if (this.grid) {
            return this.grid.data as GridDataResult;
        } else {
            return null;
        }
    }
}
